import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import { useLocation, useParams, useNavigate, Link } from "react-router-dom";
import URLstateContext from "../../../provider/CommonContext";
import Pagination from '../../CommonUI/Pagination/Pagination';
import './MutualFundHoldings.css';
import { Vortex } from 'react-loader-spinner'
 function MutualFundHoldings(props) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [loadingshow, setloadingshow] = useState(false);
  const [dataExchange, setExchangeData] = useState("nse");
  const location = useLocation();
  const {  MFcode } = useParams();
//   console.log(MFCode,"MFCode")
  const [data, setData] = useState([]);
  const [exchange, setexchange] = useState(['']);
  let getcompname, getData;
  let getMFCode = props.MFcode;
  const childRef = useRef(null);
  const { BaseURL } = useContext(URLstateContext);
  const [currentPage, setCurrentPage] = useState(1);
  let PageSize = 5;
  useEffect(() => {
    setloadingshow(true);
    if(getMFCode != '') {
    const getUrl = BaseURL + "HoldingsMF";
    // console.log(cocode)
    fetch(`${getUrl}/${getMFCode}/5`)
      // console.log(MFCode,"COCODE")
        .then((response) => response.json())
        .then((data) => {
            //  console.log(data,"dataHold");
            getData = data.data;
            setData(getData);
            setloadingshow(false);
            // console.log("data",data);
        })
        .catch((error) => {
            //  console.log("not found the api 1233333");
        });
    }
}, [getMFCode]);


const currentTableData = useMemo(() => {
  if (data != null && data != []) {
      const firstPageIndex = (currentPage - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      if (data != null && data != []) {
          if (data.length > 0) {
              return data.slice(firstPageIndex, lastPageIndex);
          }
      }
  }
}, [currentPage, data]);

const routeChange = (paramcode, paramname) => {
    window.open("/Mutual-Fund/" + paramname.replace(/ /g, '_').replace('&', 'and').replace('+', ''), "_blank");
}
  return (
    <>
     <section className="peer-sc">
            <div className='container table-boxHoldingsMutual'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h3 className="mainHeadingGroup">Top 5 Holdings</h3>
                        <div className="table-responsive">
                            <table className="table table-sm table-striped table-bordered table-hover">

                                <thead className='heading'>

                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">Sector</th>
                                        <th scope="col">Instrument</th>
                                        <th scope="col">Assets<span className="muted">%</span></th>
                                    </tr>

                                </thead>
                                {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                <tbody>
                                    {data && data.map(
                                        ({CO_CODE, CO_NAME, IIND_NAME, MKTVALUE, PERC_HOLD, TYPE }) => (
                                            <tr className="">
                                                <td className="peerdata"> {CO_NAME}</td>
                                                {/* <td><h6 className="forhover" onClick={() => routeChange(CO_CODE, CO_NAME)}>{CO_NAME} </h6></td> */}
                                                <td className="peerdata"> {IIND_NAME}</td>
                                                <td className="peerdata"> {TYPE}</td>
                                                <td className="peervalue"> {(PERC_HOLD != null) ? PERC_HOLD.toFixed(2) : PERC_HOLD = 0}</td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                            {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                        </div>
                        {/* {(data != null && data != []) ?
                            <Pagination
                                className="pagination-bar_peer"
                                currentPage={currentPage}
                                totalCount={(data.length != null) ? data.length : 0}
                                pageSize={PageSize}
                                onPageChange={page => setCurrentPage(page)}
                            /> : <p className="errorPeer"> No Data Found !!! </p>} */}
                    </div>
                </div>
            </div>
        </section>


    </>
  )
}
export default MutualFundHoldings;
